import React from 'react';
import type { FallbackProps } from 'react-error-boundary';
import { useRouter } from 'next/router';

import C1UserErrorPage from '~/components/C1UserErrorPage';
import ErrorPage from '~/components/ErrorPage';
import NonLoginErrorPage from '~/components/NonLoginErrorPage';
import { useGoHome } from '~/hooks/url';
import { OAIApiError } from '~/libs/openApiError';
import { logError } from '~/utils/datadog';

const RootErrorFallback = ({ error, resetErrorBoundary }: FallbackProps) => {
  const router = useRouter();
  const goHome = useGoHome('replace');
  const handleResetError = React.useCallback(() => {
    resetErrorBoundary();
    goHome();
  }, [goHome, resetErrorBoundary]);

  React.useEffect(() => {
    // 억지로 history.back을 하려고하면 error를 reset한다.
    router.events.on('routeChangeComplete', handleResetError);
    return () => router.events.off('routeChangeComplete', handleResetError);
  }, [handleResetError, router.events]);

  if (error instanceof OAIApiError && error.statusCode === 401) {
    // 로그인 안했을 떄
    return <NonLoginErrorPage />;
  }

  if (error instanceof OAIApiError && error.statusCode === 403) {
    // 로그인 했는데 사업장 없을 때 (c1 유저일 떄)
    return <C1UserErrorPage />;
  }

  if (error instanceof OAIApiError) {
    logError(error);
  }

  return <ErrorPage onResetClick={handleResetError} />;
};

export default RootErrorFallback;
